module.exports = __webpack_public_path__ + "assets/img/2.ea40b90d.png";